import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, Children } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import PopOver from '../PopOver/PopOver.js';
import Icon from '../Icon/Icon.js';
import styles from './Expandable.module.scss.js';

function Expandable(_ref) {
  var title = _ref.title,
    children = _ref.children,
    expanded = _ref.expanded,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    toolTip = _ref.toolTip,
    icon = _ref.icon;
  var _useState = useState(expanded),
    _useState2 = _slicedToArray(_useState, 2),
    contentExpanded = _useState2[0],
    setContentExpanded = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    tooltipVisible = _useState4[0],
    setTooltipVisible = _useState4[1];
  var arrowDirection = contentExpanded ? 'up' : 'down';
  var getItems = function getItems() {
    return Children.map(children, function (child, index) {
      var keyd = "in".concat(index);
      var c = null;
      if (child) {
        c = /*#__PURE__*/React.createElement("li", {
          key: keyd,
          className: styles.listItem
        }, child);
      }
      return c;
    });
  };
  var items = children ? getItems() : '';
  var expandable = children && items.length > 0;
  return /*#__PURE__*/React.createElement("article", {
    className: classNames(styles.wrapper, className),
    id: dataTestId
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classNames(styles.button, contentExpanded && styles.expanded),
    onClick: function onClick() {
      return setContentExpanded(!contentExpanded);
    },
    id: dataTestId && "".concat(dataTestId, "-button"),
    disabled: !expandable
  }, /*#__PURE__*/React.createElement("section", {
    className: styles.titleSection
  }, icon && /*#__PURE__*/React.createElement("section", {
    className: styles.iconSection
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    className: styles.icon,
    size: "medium",
    color: "green"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "title"
  }, title, " "), toolTip && /*#__PURE__*/React.createElement("section", {
    className: styles.toolTip
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "icon-help-domain",
    className: styles.toolTipIcon,
    mouseOver: function mouseOver() {
      return setTooltipVisible(true);
    },
    mouseLeave: function mouseLeave() {
      return setTooltipVisible(false);
    },
    size: "small"
  }), tooltipVisible && /*#__PURE__*/React.createElement(PopOver, {
    visible: tooltipVisible,
    className: styles.popover
  }, /*#__PURE__*/React.createElement("p", null, toolTip)))), expandable && /*#__PURE__*/React.createElement(Icon, {
    icon: "icon-arrow-".concat(arrowDirection),
    className: styles.chevron
  })), expandable && /*#__PURE__*/React.createElement(CSSTransition, {
    "in": contentExpanded,
    appear: contentExpanded,
    classNames: "content",
    timeout: 0
  }, /*#__PURE__*/React.createElement("ul", {
    className: styles.content
  }, items)));
}
Expandable.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  expanded: PropTypes.bool,
  className: PropTypes.string,
  toolTip: PropTypes.string,
  dataTestId: PropTypes.string,
  icon: PropTypes.string
};
Expandable.defaultProps = {
  children: null,
  expanded: false,
  className: '',
  toolTip: null,
  dataTestId: null,
  icon: null
};

export { Expandable as default };
